
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.7 31c-1.2 0-2.6-.2-3.9-.6-.2-.1-.4-.2-.5-.4L14 25.9 11.8 30c-.1.2-.3.3-.5.4-5.4 1.5-10.1-.6-10.3-.8-.3-.2-.5-.5-.5-.8 0-.2.5-6.5 1.3-9.8 1-4 1.3-7.4 1.3-7.4 0-.4.4-.7.8-.7h20.2c.4 0 .8.3.8.7 0 0 .2 3.5 1.3 7.4.7 3.2 1.3 9.5 1.3 9.7 0 .3-.2.6-.5.8-.1.3-2.8 1.5-6.3 1.5zm-3.2-2c3.8 1 7.2-.1 8.4-.6-.2-1.7-.6-6.3-1.2-8.9-.8-3.1-1.1-5.7-1.2-6.9H4.6c-.2 1.3-.5 3.9-1.2 6.9-.6 2.6-1.1 7.3-1.2 9 1.3.5 4.7 1.5 8.4.6l2.7-5.1c.2-.2.4-.4.7-.4.3 0 .6.2.7.4l2.8 5z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M3.2 6.3h21.7v3.1H3.2V6.3zm4.6-4.6h21.7v3.1H7.8V1.7z","fill":"#F9A91E"}}),_c('path',{attrs:{"d":"M30.9 14.4c-1-3.9-1.3-7.4-1.3-7.4 0-.4-.4-.7-.8-.7h-2.4V8h1.8c.1 1.2.4 3.9 1.2 6.9.6 2.6 1 7.2 1.2 8.9-.4.2-1.1.4-1.9.6h-.2l.2 1.6c1.8-.4 2.9-.9 3-1.1.3-.2.5-.5.5-.8 0-.2-.6-6.5-1.3-9.7z","fill":"#47AEA6"}})])
          )
        }
      }
    